<template>
  <v-navigation-drawer
    v-model="$root.drawer"
    elevation-3
    app
    clipped
    width="300px"
    hide-overlay
    color="grey_light"
  >
    <!-- <v-app-bar flat color="#303030">
      <v-row align="center" justify="center">
        <p class="pt-6 primary--text">
          Navigation
        </p>
        <v-spacer />
        <v-icon>mdi-chevron-left</v-icon>
      </v-row>
    </v-app-bar> -->
    <v-list class="pa-0" color="grey_light">
      <v-list-item-group
        v-model="active"
        mandatory
        active-class="primary white--text"
      >
        <inertia-link v-if="$page.props.user.permissions.offer.admin_view" :href="route('admin.dashboard')">
          <v-list-item :value="route('admin.dashboard')" @click="$root.drawer = false">
            <v-list-item-icon>
              <v-icon>mdi-cart-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-button">
                Admin-Ansicht
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </inertia-link>

        <v-divider class="border-white" />

        <inertia-link :href="route('dashboard')">
          <v-list-item :value="route('dashboard')" @click="$root.drawer = false">
            <v-list-item-icon>
              <v-icon> home-circle-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-button">
                Dashboard
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </inertia-link>
        <inertia-link :href="route('todo')">
          <v-list-item :value="route('todo')" @click="$root.drawer = false">
            <v-list-item-icon>
              <v-icon>mdi-alert-circle-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-button">
                TODO
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </inertia-link>

        <v-divider class="border-white" />

        <inertia-link :href="route('customer.index')">
          <v-list-item :value="route('customer.index')" @click="$root.drawer = false">
            <v-list-item-icon>
              <v-icon>mdi-account-group-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="d-flex justify-space-between">
                <span class="text-button">
                  Kundenübersicht
                </span>
                <inertia-link :href="route('customer.create')">
                  <v-icon>
                    mdi-plus-circle
                  </v-icon>
                </inertia-link>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </inertia-link>

        <v-divider class="border-white" />

        <inertia-link :href="route('offerData.index')">
          <v-list-item :value="route('offerData.index')" @click="$root.drawer = false">
            <v-list-item-icon>
              <v-icon>mdi-information-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-button">
                Preisinformationen
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </inertia-link>

        <v-divider class="border-white" />

        <inertia-link :href="route('offer.index', {tab: 'freigegeben'})">
          <v-list-item :value="route('offer.index', {tab: 'freigegeben'})" @click="$root.drawer = false">
            <v-list-item-icon>
              <v-icon>mdi-clipboard-check-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-button">
                freigegebene Angebote
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </inertia-link>

        <v-divider class="border-white" />

        <inertia-link :href="route('offer.index', {tab: 'prozess'})">
          <v-list-item :value="route('offer.index',{tab: 'prozess'})" @click="$root.drawer = false">
            <v-list-item-icon>
              <v-icon>mdi-timer-sand</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-button">
                Angebotsprozess
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </inertia-link>

        <v-divider class="border-white" />

        <inertia-link :href="route('offer.index', {tab: 'angenommen'})">
          <v-list-item :value="route('offer.index', {tab: 'angenommen'})" @click="$root.drawer = false">
            <v-list-item-icon>
              <v-icon>mdi-clipboard-text-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-button">
                angenommene Angebote
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </inertia-link>

        <v-divider class="border-white" />

        <v-list-group
          no-action
          sub-group
        >
          <template #activator>
            <v-list-item-content>
              <v-list-item-title>Verträge</v-list-item-title>
            </v-list-item-content>
          </template>

          <inertia-link :href="route('contract.index')">
            <v-list-item :value="route('contract.index')" @click="$root.drawer = false">
              <v-list-item-icon>
                <v-icon>mdi-clipboard-clock-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-button">
                  Verträge
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </inertia-link>
          <inertia-link v-if="$page.props.user.permissions.offer.admin_view" :href="route('statistic.contract.index')">
            <v-list-item :value="route('statistic.contract.index')" @click="$root.drawer = false">
              <v-list-item-icon>
                <v-icon>mdi-clipboard-clock-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-button">
                  Vertrags Statistik
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </inertia-link>
        </v-list-group>

        <v-divider class="border-white" />

        <inertia-link :href="route('offer.index', {type: 9})">
          <v-list-item :value="route('offer.index', {type: 9})" @click="$root.drawer = false">
            <v-list-item-icon>
              <v-icon>mdi-clipboard-text-off-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-button">
                abgelehnte Angebote
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </inertia-link>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { Link as InertiaLink } from '@inertiajs/inertia-vue'
export default {

   name: 'Sidebar',
   components: {
      InertiaLink
   },
   data () {
      return {
         active: this.route('dashboard') + this.$page.url
      }
   },
   mounted () {
      //   this.active = this.route('home') + this.$page.url
   },
   methods: {
      navigateTo (route) {
         this.$inertia.visit(this.route(route))
         this.$root.drawer = false
      }
   }
}
</script>
